var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddParkingBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.2,
    height: 38.766,
    viewBox: "0 0 37.2 38.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9086",
    transform: "translate(-37.8 -594)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9080"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7834",
    d: "M22.508 4H9.538A3.538 3.538 0 0 0 6 7.538v25.941a3.538 3.538 0 0 0 3.538 3.538h23.583a3.538 3.538 0 0 0 3.538-3.538V20.508a3.538 3.538 0 0 0-3.538-3.538h-7.075V7.538A3.538 3.538 0 0 0 22.508 4zM7.179 33.479V7.538a2.358 2.358 0 0 1 2.359-2.359h12.97a2.358 2.358 0 0 1 2.358 2.358v28.3H20.15v-7.664a.59.59 0 0 0-.59-.59h-7.075a.59.59 0 0 0-.59.59v7.665H9.538a2.358 2.358 0 0 1-2.359-2.359zm5.9 2.358v-7.074h5.9v7.075zM33.121 18.15a2.358 2.358 0 0 1 2.358 2.358v12.971a2.358 2.358 0 0 1-2.358 2.358h-7.075V18.15z",
    style: {
      stroke: "currentColor",
      strokeWidth: ".4px",
      fill: "currentColor"
    },
    transform: "translate(32 595.549)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7835",
    d: "M12.59 13.538h2.358a.59.59 0 0 0 .59-.59V10.59a.59.59 0 0 0-.59-.59H12.59a.59.59 0 0 0-.59.59v2.358a.59.59 0 0 0 .59.59zm.59-2.358h1.179v1.179h-1.18zm-.59 8.254h2.358a.59.59 0 0 0 .59-.59v-2.359a.59.59 0 0 0-.59-.59H12.59a.59.59 0 0 0-.59.59v2.358a.59.59 0 0 0 .59.59zm.59-2.358h1.179v1.179h-1.18zm1.769 8.254a.59.59 0 0 0 .59-.59v-2.359a.59.59 0 0 0-.59-.59H12.59a.59.59 0 0 0-.59.59v2.359a.59.59 0 0 0 .59.59zm-1.769-2.358h1.179v1.178h-1.18zm8.844-9.433h2.358a.59.59 0 0 0 .59-.59V10.59a.59.59 0 0 0-.59-.59h-2.359a.59.59 0 0 0-.59.59v2.358a.59.59 0 0 0 .59.59zm.59-2.358h1.179v1.179h-1.18zm-.59 8.254h2.358a.59.59 0 0 0 .59-.59v-2.36a.59.59 0 0 0-.59-.59h-2.359a.59.59 0 0 0-.59.59v2.358a.59.59 0 0 0 .59.59zm.59-2.358h1.179v1.179h-1.18zm-.59 8.254h2.358a.59.59 0 0 0 .59-.59v-2.36a.59.59 0 0 0-.59-.59h-2.359a.59.59 0 0 0-.59.59v2.359a.59.59 0 0 0 .59.589zm.59-2.358h1.179v1.177h-1.18zm10.023 3.538h2.358a.59.59 0 0 0 .59-.59v-2.36a.59.59 0 0 0-.59-.59h-2.359a.59.59 0 0 0-.59.59v2.358a.59.59 0 0 0 .59.589zm.59-2.358H34.4v1.179h-1.175zm-.59 8.254h2.358a.59.59 0 0 0 .59-.59v-2.361a.59.59 0 0 0-.59-.59h-2.359a.59.59 0 0 0-.59.59v2.358a.59.59 0 0 0 .59.586zm.59-2.358H34.4v1.179h-1.175z",
    transform: "translate(29.538 593.087)",
    style: {
      stroke: "currentColor",
      strokeWidth: ".4px",
      fill: "currentColor"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 603",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(49 594)",
    style: {
      fill: "var(--sidebar-surface)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7837",
    d: "M14.769 8.9h-1.958v3.916H8.9v1.958h3.916v3.916h1.958v-3.921h3.916v-1.958h-3.921zM13.79 4a9.79 9.79 0 1 0 9.79 9.79A9.787 9.787 0 0 0 13.79 4zm0 17.622a7.832 7.832 0 1 1 7.832-7.832 7.842 7.842 0 0 1-7.832 7.832z",
    transform: "translate(48.056 593.056)",
    style: {
      fill: "currentColor"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddParkingBuilding);
export default __webpack_public_path__ + "static/media/add_parking_building.2143f7505b94aff0554fe01755eff152.svg";
export { ForwardRef as ReactComponent };